import * as UserConstants from '../constants/user-constants';
import API from '../api/user-api';
import { interceptor } from "../services/interceptor-service";

export const appSignUp = (userData) => dispatch => {
  dispatch(appSignupRequest(userData));
  API.appSignUp(userData)
    .then(response => {
        if (response.data.user && response.data.token) {
          const token = response.data.token;
          const accessToken = response.data.accessToken;
          const refreshToken = response.data.refreshToken;
          const user = response.data.user;
          user.sortKey = 'liveli';
          interceptor.addValue('accessToken',accessToken);
          interceptor.addValue('refreshToken',refreshToken);
          interceptor.addToken(token);
          interceptor.addValue('user', JSON.stringify(user));
          dispatch(appSignupSuccess(response.data));
        }
        if (response.data.errorMessage) {
          dispatch(appSignupFailure(response.data));
        }
    })
    .catch(error => {
        dispatch(appSignupFailure(error.response));
    })
}

const appSignupRequest = (data) => {
  return {
    type: UserConstants.APP_SIGNUP_REQUEST,
    data
  }
}


const appSignupSuccess= (data) => {
  return {
    type: UserConstants.APP_SIGNUP_SUCCESS,
    data
  }
}

const appSignupFailure = (error) => {
  return {
    type: UserConstants.APP_SIGNUP_FAILURE,
    error
  }
}

export const appLogin = (data) => dispatch => {
  dispatch(appLoginRequest(data));
  API.appLogin(data)
    .then(response => {
      if (response.data.errorMessage) {
        dispatch(appLoginFailure(response.data));
      }
      if (response.data.token) {
        const user = response.data.user;
        user.sortKey = "liveli";
        const token = response.data.token;
        const accessToken = response.data.accessToken;
        const refreshToken = response.data.refreshToken;
        interceptor.addValue('accessToken',accessToken);
        interceptor.addValue('refreshToken',refreshToken);
        interceptor.addToken(token);
        interceptor.addValue('user', JSON.stringify(user));
        dispatch(appLoginSuccess(response.data));
      }
    })
    .catch(error => {
      dispatch(appLoginFailure(error))
    })
}

const appLoginRequest = (data) => {
  return {
    type: UserConstants.LOGIN_REQUEST,
    data
  }
}

const appLoginSuccess = (data) => {
  return {
    type: UserConstants.LOGIN_SUCCESS,
    data
  }
}

const appLoginFailure = (error) => {
  return {
    type: UserConstants.LOGIN_FAILURE,
    error
  }
}

export const getAppUser = (data) => dispatch => {
  const userInfo = JSON.parse(localStorage.getItem('user'));
  dispatch(getAppUserRequest());
  API.getUserData(userInfo)
    .then(response => {
        if (response.data) {
          let userData = response.data;
          if (!userData.checklist && !userData.notes && !userData.weather && !userData.reminders) {
            userData = {
              ...userData,
              checklist: [],
              reminders: [],
              weather: [],
              notes: []
            }
          }
          localStorage.setItem('userProfile', JSON.stringify(userData)); 
          dispatch(getAppUserSuccess(userData));
        }
        if (!response) {
          dispatch(getAppUserFailure(null));
        }
    })
    .catch(error => {
        dispatch(getAppUserFailure(error));
    })
}

const getAppUserRequest = (data) => {
  return {
    type: UserConstants.APP_GET_USER_REQUEST,
    data
  }
}

const getAppUserSuccess= (data) => {
  return {
    type: UserConstants.APP_GET_USER_SUCCESS,
    data
  }
}

const getAppUserFailure = (error) => {
  return {
    type: UserConstants.APP_GET_USER_FAILURE,
    error
  }
}


export const logout = () => dispatch => {
  interceptor.removeToken();
  dispatch(setCurrentUser({}))
}

const setCurrentUser = (user) => {
  return {
    type: UserConstants.SET_CURRENT_USER,
    payload: user
  }
}
//Actions when user is trying to recover password
export const recoverPassword = (data) => dispatch => {
  dispatch(recoverPasswordRequest(data));
  API.recoverPassword(data)
    .then(response => {
      dispatch(recoverPasswordSuccess(response))
    })
    .catch((error) => {
      dispatch(recoverPasswordFailure(error.response, data));
    });
}

const recoverPasswordRequest = (data) => {
  return {
    type: UserConstants.RECOVER_PASS_REQUEST,
    data
  }
}

const recoverPasswordSuccess = (data) => {
  return {
    type: UserConstants.RECOVER_PASS_SUCCESS,
    data
  }
}

const recoverPasswordFailure = (e, data) => {
  return {
    type: UserConstants.RECOVER_PASS_FAILURE,
    error: e,
    data,
  }
}

//Actions when user changes password via email
export const changePassword = (data, token, defaultPass) => dispatch => {
  dispatch(changePasswordRequest(data));
  API.changePassword(data, token)
    .then(response => {
      if (defaultPass) {
        dispatch(changePasswordSuccess(response))
        // dispatch(login(data))
      } else {
        dispatch(changePasswordSuccess(response))
      }
    })
    .catch((error) => {
      dispatch(changePasswordFailure(error.response));
    });
}

const changePasswordRequest = () => {
  return {
    type: UserConstants.CHANGE_PASS_REQUEST,
  }
}

const changePasswordSuccess = () => {
  return {
    type: UserConstants.CHANGE_PASS_SUCCESS,
  }
}

const changePasswordFailure = (e) => {
  return {
    type: UserConstants.CHANGE_PASS_FAILURE,
    error: e,
  }
}

export const clearState = () => {
  return {
    type: UserConstants.CLEAR_USER_STATE
  }
}

export const clearLoadingUser = (payload) => {
  return {
    type: UserConstants.CLEAR_LOADING_USER,
    payload
  }
}

export const clearUserState = (payload) => {
  return {
    type: UserConstants.CLEAR_USER_STATE,
    payload
  }
}

//Actions when user login with facebook or google
export const socialLogin = (data) => dispatch => {
  dispatch(socialLoginRequest(data));
  API.socialLogin(data)
    .then(response => {
      if (response.data.token){
        const user = response.data.user;
        user.sortKey = data.sortKey;
        const token = response.data.token;
        const accessToken = response.data.accessToken;
        const refreshToken = response.data.refreshToken;
        interceptor.addValue('accessToken', accessToken);
        interceptor.addValue('refreshToken', refreshToken);
        interceptor.addToken(token);
        interceptor.addValue('user', JSON.stringify(user));
      } 
      dispatch(socialLoginSuccess(response));
    })
    .catch(error => {
      dispatch(socialLoginFailure(error))
    })
}

const socialLoginRequest = (data) => {
  return {
    type: UserConstants.SOCIAL_LOGIN_REQUEST,
    data
  }
}

const socialLoginSuccess = (data) => {
  return {
    type: UserConstants.SOCIAL_LOGIN_SUCCESS,
    data
  }
}

const socialLoginFailure = (e) => {
  return {
    type: UserConstants.SOCIAL_LOGIN_FAILURE,
    error: e
  }
}

//Actions for forgot password
export const forgotPassword = (data) => dispatch => {
  dispatch(forgotPasswordRequest(data));
  API.forgotPassword(data)
    .then(response => {
      dispatch(forgotPasswordSuccess(response));
    })
    .catch(error => {
      dispatch(forgotPasswordFailure(error))
    })
}

const forgotPasswordRequest = (data) => {
  return {
    type: UserConstants.RECOVER_PASS_REQUEST,
    data
  }
}

const forgotPasswordSuccess = (data) => {
  return {
    type: UserConstants.RECOVER_PASS_SUCCESS,
    data
  }
}

const forgotPasswordFailure = (e) => {
  return {
    type: UserConstants.RECOVER_PASS_FAILURE,
    error: e
  }
}

//Actions for forgot password verify link
export const forgotPasswordVerifyLink = (data) => dispatch => {
  dispatch(forgotPasswordVerifiLinkRequest(data));
  API.forgotPasswordVerifyLink(data)
    .then(response => {
      dispatch(forgotPasswordVerifiLinkSuccess(response));
    })
    .catch(error => {
      dispatch(forgotPasswordVerifiLinkFailure(error))
    })
}

const forgotPasswordVerifiLinkRequest = (data) => {
  return {
    type: UserConstants.RECOVER_PASS_VERIFY_LINK_REQUEST,
    data
  }
}

const forgotPasswordVerifiLinkSuccess = (data) => {
  return {
    type: UserConstants.RECOVER_PASS_VERIFY_LINK_SUCCESS,
    data
  }
}

const forgotPasswordVerifiLinkFailure = (e) => {
  return {
    type: UserConstants.RECOVER_PASS_VERIFY_LINK_FAILURE,
    error: e
  }
}

//Actions for forgotPasswordChangePassword
export const forgotPasswordChangePassword = (data) => dispatch => {
  dispatch(forgotPasswordChangePasswordRequest(data));
  API.forgotPasswordChangePassword(data)
    .then(response => {
      dispatch(forgotPasswordChangePasswordSuccess(response));
    })
    .catch(error => {
      dispatch(forgotPasswordChangePasswordFailure(error))
    })
}

const forgotPasswordChangePasswordRequest = (data) => {
  return {
    type: UserConstants.CHANGE_PASS_REQUEST,
    data
  }
}

const forgotPasswordChangePasswordSuccess = (data) => {
  return {
    type: UserConstants.CHANGE_PASS_SUCCESS,
    data
  }
}

const forgotPasswordChangePasswordFailure = (e) => {
  return {
    type: UserConstants.CHANGE_PASS_FAILURE,
    error: e
  }
}

//Actions for logOut
export const logOut = (data) => dispatch => {
  dispatch(logOutRequest(data));
  API.logOut(data)
    .then(response => {
      dispatch(logOutSuccess(response));
      dispatch(clearState())
    })
    .catch(error => {
      dispatch(logOutFailure(error))
    })
}

const logOutRequest = (data) => {
  return {
    type: UserConstants.LOGOUT_REQUEST,
    data
  }
}

const logOutSuccess = (data) => {
  return {
    type: UserConstants.LOGOUT_SUCCESS,
    data
  }
}

const logOutFailure = (e) => {
  return {
    type: UserConstants.LOGOUT_FAILURE,
    error: e
  }
}

//Actions for put Badge Color
export const putBadgeColor = (data) => dispatch => {
  dispatch(putBadgeColorRequest(data));
  API.putBadgeColor(data)
    .then(response => {
      dispatch(clearUserState());
      dispatch(putBadgeColorSuccess(response));
    })
    .catch(error => {
      dispatch(putBadgeColorFailure(error))
    })
}

export const putBadgeColorPromise = (data) => {
  return API.putBadgeColor(data);
}

const putBadgeColorRequest = (data) => {
  return {
    type: UserConstants.PUT_BADGE_COLOR_REQUEST,
    data
  }
}

const putBadgeColorSuccess = (data) => {
  return {
    type: UserConstants.PUT_BADGE_COLOR_SUCCESS,
    data
  }
}

const putBadgeColorFailure = (e) => {
  return {
    type: UserConstants.PUT_BADGE_COLOR_FAILURE,
    error: e
  }
}

//Actions for get Badge Color
export const getBadgeColor = (data) => dispatch => {
  dispatch(getBadgeColorRequest(data));
  API.getBadgeColor(data)
    .then(response => {
      dispatch(getBadgeColorSuccess(response));
    })
    .catch(error => {
      dispatch(getBadgeColorFailure(error))
    })
}

const getBadgeColorRequest = (data) => {
  return {
    type: UserConstants.GET_BADGE_COLOR_REQUEST,
    data
  }
}

const getBadgeColorSuccess = (data) => {
  return {
    type: UserConstants.GET_BADGE_COLOR_SUCCESS,
    data
  }
}

const getBadgeColorFailure = (e) => {
  return {
    type: UserConstants.GET_BADGE_COLOR_FAILURE,
    error: e
  }
}

//actions for change liveli passeword
export const changeLiveliPassword = (data) => dispatch => {
  dispatch(changeLiveliPasswordRequest(data));
  API.changeLiveliPassword(data)
    .then(response => {
      dispatch(changeLiveliPasswordSuccess(response));
    })
    .catch(error => {
      dispatch(changeLiveliPasswordFailure(error))
    })
}

const changeLiveliPasswordRequest = () => {
  return {
    type: UserConstants.CHANGE_LIVELI_PASS_REQUEST,
  }
}

const changeLiveliPasswordSuccess = (data) => {
  return {
    type: UserConstants.CHANGE_LIVELI_PASS_SUCCESS,
    data
  }
}

const changeLiveliPasswordFailure = (e) => {
  return {
    type: UserConstants.CHANGE_LIVELI_PASS_FAILURE,
    error: e,
  }
}

// Actions for set users values
const NotificationsBegin = (data) => {
  return {
    type: UserConstants.INITIAL_NOTIFICATIONS,
    data
  }
}

export const setNotifications = (data) => dispatch =>  {
  dispatch(NotificationsBegin(data))
}

const setCalendarDefaultView = (defaultView, date) => {
  return {
    type: UserConstants.SET_CALENDAR_DEFAULT_VIEW,
    defaultView,
    date
  }
}

export const setDefaultView = (defaultView, date) => dispatch => {
  dispatch(setCalendarDefaultView(defaultView, date))
}

const setCalendarSettings = (weather, location) => {
  return {
    type: UserConstants.SET_CALENDAR_SETTINGS,
    weather,
    location
  }
}

export const setSettings = (weather, location) => dispatch => {
  dispatch(setCalendarSettings(weather, location))
}

const setCalendarSettingsChanges = (hasChangesSettings) => {
  return {
    type: UserConstants.SET_CALENDAR_CHANGES,
    hasChangesSettings
  }
}

export const setSettingsChanges = (hasChangesSettings) => dispatch => {
  dispatch(setCalendarSettingsChanges(hasChangesSettings))
}

// Actions for set step values
const setStepTutorial = (step) => {
  return {
    type: UserConstants.SET_STEP_TUTORIAL,
    step
  }
}

export const setStep = (step) => dispatch =>  {
  dispatch(setStepTutorial(step))
}

// Actions for show tutorial
const showToturial = (show, isTutorial, isFirstTutorial) => {
  return {
    type: UserConstants.SHOW_TUTORIAL,
    show,
    isTutorial,
    isFirstTutorial
  }
}

export const setShowTutorial = (show, isTutorial, isFirstTutorial) => dispatch =>  {
  dispatch(showToturial(show, isTutorial, isFirstTutorial))
}

//Actions for get Settings Credentials
export const getSettingsCredentials = () => dispatch => {
  dispatch(getSettingsCredentialsRequest());
  API.getSettingsCredentials()
    .then(response => {
      dispatch(getSettingsCredentialsSuccess(response));
    })
    .catch(error => {
      dispatch(getSettingsCredentialsFailure(error))
    })
}

const getSettingsCredentialsRequest = (data) => {
  return {
    type: UserConstants.GET_SETTINGS_REQUEST,
    data
  }
}

const getSettingsCredentialsSuccess = (data) => {
  return {
    type: UserConstants.GET_SETTINGS_SUCCESS,
    data
  }
}

const getSettingsCredentialsFailure = (e) => {
  return {
    type: UserConstants.GET_SETTINGS_FAILURE,
    error: e
  }
}

//Actions for send email
const sendWelcomeEmailBegin = (data) => {
  return {
      type: UserConstants.SEND_WELCOME_EMAIL_BEGIN,
      data
  }
}

const sendWelcomeEmailSuccess = (data) => {
  return {
      type: UserConstants.SEND_WELCOME_EMAIL_SUCCESS,
      data
  }
}

const sendWelcomeEmailError = (error) => {
  return {
      type: UserConstants.SEND_WELCOME_EMAIL_FAILURE,
      error
  }
}

export const sendWelcomeEmail = (data) => (dispatch) => {
  dispatch(sendWelcomeEmailBegin(data));
  API.sendWelcomeEmail(data)
      .then((response) => {
          dispatch(sendWelcomeEmailSuccess(response));
      })
      .catch((err) => {
          dispatch(sendWelcomeEmailError(err));
      });
}